import * as React from 'react'

import SearchInput from '~/client/src/shared/components/Filters/SearchInput/SearchInput'

import { useResource } from '../context'

export const ResourceSearch: React.FC = () => {
  const {
    state: { searchKey },
    actions: { setSearchKey },
  } = useResource()

  return (
    <div className="tw:flex tw:items-center tw:grow-0">
      <SearchInput
        value={searchKey || ''}
        onChange={setSearchKey}
        testId="resource-search-input"
      />
    </div>
  )
}
